import OrderUpdateRequest, {
  OrderUpdateRequestBody,
} from "./order-update.request";

const createBody = (request: OrderUpdateRequest): OrderUpdateRequestBody => {
  return {
    forceAllowToll: request.forceAllowToll,
    orderId: request.orderId,
    rv_1: request.rv1,
    rv_2: request.rv2,
  };
};

const orderUpdateRequestFactory = {
  createBody,
};

export default orderUpdateRequestFactory;
